<!-- 
Descripción de la vista

Tener por puesto la ocupación de los trabajadores

Filtros: 
- Puesto
- Plantel

Campos:
- Plantel
- Cuántos trabajadores hay
- Cuántos trabajadores faltan
- Turno

<Tener en cuenta>
- Porcentaje de sucursales completas en cuanto personal (sucursales en riesgo operativo)
- Porcentaje de avance de capacidad operativa (mejor o peor que la semana anterior)
</Tener en cuenta>
-->

<template>
	<v-dialog
    v-model="dialogReporteOcupacion.estatus"
    hide-overlay
    persistent
    max-width="1200"
  >
    <v-card>
      <v-card-title primary-title >
        <v-icon left>mdi-account-group</v-icon> Reporte de ocupación
        <v-spacer></v-spacer>

        <v-btn color="green" dark small tile @click="exportExcel( filterReporte, 'REPORTE_OCUPACION' )" class="mr-2">
          <v-icon small>mdi-microsoft-excel</v-icon>
        </v-btn>

        <v-btn color="primary" dark small tile @click="initialize()" class="mr-4">
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>

      </v-card-title>
      <v-card-text>

        <!-- Sección de filtros -->
        <v-row>

          <!-- Filtro por planteles, autocomplete -->
          <v-col cols="12" md="6" lg="4">
            <v-autocomplete
              :items="planteles"
              label="Selecciona un plantel"
              item-text="plantel"
              item-value="id_plantel"
              dense
              filled
              clearable
              hide-details
              v-model="plantel_seleccionado"
            ></v-autocomplete>
          </v-col>

          <!-- Filtro por puestos, autocomplete -->
          <v-col cols="12" md="6" lg="4">
            <v-autocomplete
              :items="puestos"
              label="Selecciona un puesto"
              item-text="puesto"
              item-value="id_puesto"
              dense
              filled
              clearable
              hide-details
              v-model="puesto_seleccionado"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headersRezagados"
              :items="filterReporte"
              class="elevation-0"
              dense
            >

              <template v-slot:item.autorizados="{ item }">
                <v-chip color="green" small dark @click="dialogPersonal = true, personal = item.autorizados">{{ item.autorizados.length }}</v-chip>
              </template>

              <template v-slot:item.ocupacion="{ item }">
                <v-chip color="red" small dark @click="dialogPersonal = true, personal = item.ocupacion">{{ item.ocupacion.length }}</v-chip>
              </template>

              <template v-slot:item.faltantes="{ item }">
                <v-chip color="yellow" small  @click="dialogPersonal = true, personal = item.faltantes">{{ item.faltantes.length }}</v-chip>
              </template>

              <template v-slot:item.percent_ocupacion="{ item }">
                <v-chip color="green"  v-if="item.percent_ocupacion >= 100" small dark >{{ item.percent_ocupacion }}%</v-chip>
                <v-chip color="yellow" v-else-if="item.percent_ocupacion >= 80" small  >{{ item.percent_ocupacion }}%</v-chip>
                <v-chip color="red"    v-else                 small dark >{{ item.percent_ocupacion }}%</v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error"   dark @click="cerrar()">Cancelar</v-btn>
      </v-card-actions>
      <v-btn 
        color="transparent elevation-0"
        x-small
        absolute
        top
        right
        fab
        class="mt-5 mr-0"
        @click="cerrar()"
       ><v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>

    <!-- Dialog de personal -->
    <v-dialog v-model="dialogPersonal" max-width="1200">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-account</v-icon> Personal
        </v-card-title>
        <v-card-text>
          <v-data-table 
            :headers="headersOcupacional" 
            :items="personal" 
            class="elevation-0" 
            dense
          >
          <template v-slot:item.sexo="{ item }">
              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
            </template>

            <template v-slot:item.estatus="{ item }">
              <v-chip color="green" v-if="item.estatus == 1"       small dark >Activo</v-chip>
              <v-chip color="error" v-else-if="item.estatus == 2"  small dark >Baja solicitada</v-chip>
              <v-chip color="red"   v-else                 small dark >Vacante</v-chip>
            </template>
                 
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error"   dark @click="dialogPersonal = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-dialog>
</template>
<script>
  
  import axios from 'axios';

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import { mapGetters, mapActions }  from 'vuex';


	export default {

		components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

		props:[
			'dialogReporteOcupacion',
      'planteles'
	  ],

    data: () => ({

    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      escuelaFilter: 3,

      headersRezagados: [
        { text: 'Puesto',      value: 'id_plantel'  },
        { text: 'Plantel',     value: 'plantel'     },
        { text: 'Autorizados', value: 'autorizados' },
        { text: 'Ocupación',   value: 'ocupacion'   },
        { text: 'Faltantes',   value: 'faltantes'   },
        { text: '% Ocupación', value: 'percent_ocupacion', align: 'end' },
      ],

      headersOcupacional: [
        { text: 'Folio'                , value: 'folio'                    },
        { text: 'Puesto'               , value: 'puesto'                   },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'F. Apertura'          , value: 'fecha_apertura'           },
        { text: 'Trabajador'           , value: 'trabajador'               },
        { text: 'Estatus'              , value: 'estatus'                  },
        { text: 'F. Compromiso'        , value: 'fecha_compromiso'         },
        { text: 'Reclutador'           , value: 'nombre_reclutador'        },
        { text: 'Días espera'          , value: 'dias_sin_cubrir'          },
        { text: 'Entrevistas'          , value: 'entrevistas'              },
      ],

      search:'',
      fechaAlta: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechaBaja: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      dialogPersonal: false,
      personal: [],
      puestos: [],
      puesto_seleccionado: null,
      ocupacion:[],
      plantel_seleccionado: null,
      puesto_seleccionado: null,
    }),

    async created() {
      await this.getPuestos()
      await this.initialize()
    },

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),

      filterReporte( ){

        let data = this.ocupacion

        let vacantes = []

        for( const i in data ){
          vacantes = vacantes.concat( data[i].vacantes_requeridos )
        }

        // Campos para filtrar por fechas de alta y bajas
        // fecha_alta "2019-05-31 15:24:09"
        // fecha_baja "2019-09-19 14:58:24"

        let planteles = this.planteles.filter( el => [1,2,3,4,'1','2','3','4'].includes( el.estado ) || el.plantel.match('CORPO') )

        if( this.plantel_seleccionado ){
          planteles = planteles.filter( el => el.id_plantel == this.plantel_seleccionado )
        }

        if( this.puesto_seleccionado ){
          vacantes = vacantes.filter( el => el.puesto == this.puesto_seleccionado )
        }

        for( const i in planteles ){

          const { id_plantel } = planteles[i]

          planteles[i]['autorizados'] = vacantes.filter( el => el.id_plantel == id_plantel )
          planteles[i]['ocupacion']   = vacantes.filter( el => el.id_plantel == id_plantel && el.id_trabajador )
          planteles[i]['faltantes']   = vacantes.filter( el => el.id_plantel == id_plantel && !el.id_trabajador)
          planteles[i]['percent_ocupacion'] = Math.round( ( planteles[i]['ocupacion'].length / planteles[i]['autorizados'].length ) * 100 )
        }

        // Agregar un total de autorizados, ocupacion y faltantes
        planteles.push({
          plantel: 'Total',
          id_plantel: 0,
          autorizados: vacantes,
          ocupacion: vacantes.filter( el => el.id_trabajador ),
          faltantes: vacantes.filter( el => !el.id_trabajador ),
          percent_ocupacion: Math.round( ( vacantes.filter( el => el.id_trabajador ).length / vacantes.length ) * 100 )
        })

        return planteles
      }
    },


    methods:{

      // Consultar por puesto la ocupación de los trabajadores
      async initialize(){
        this.cargar = true
        this.ocupacion = []
        this.$http.get('organigrama.v2').then(response=>{
          this.ocupacion = response.data.respuesta
          this.cargar = false
        }).catch(error=>{
          this.validError( error )
        }).finally(()=> { this.cargar = false })
      },

      getPuestos(){
        this.cargar = true
        this.puestos = []
        this.$http.get('puestos.all').then(response=>{
          this.puestos = response.data
          this.cargar = false
        }).catch(error=>{
          this.validError( error )
        }).finally(()=> { this.cargar = false })
      },

      cerrar(){
      	this.dialogReporteOcupacion.estatus = false
      	this.$emit('initialize')
      }
    }
	}
</script>
